import React, { useState } from 'react'
import Api from '../../../../_helpers/Api'
import { trans } from '../../../../_providers/Translation'
import popupDefaultHeadImage from "@/assets/img/modals/icons/head.svg"

function ChangeStatusDialog({ order, onClose, onSaved }) {

    const [newStatus, setNewStatus] = useState('')

    const statusKeys = ['approved', 'processing', 'shipped', 'delivered', 'cancelled']
    const statusOptions = statusKeys.map(key => ({
        value: key,
        label: trans(`onlineSales.orderStatus.${key}`)
    }))

    const handleSave = async () => {
        if (!newStatus || newStatus === order.status) return

        try {
            await Api.post(`/sales_orders/${order.id}/status`, { status: newStatus })
            onSaved()
        } catch (e) {
            console.log(e)
        }

        onClose()
    }

    if (!order) return null

    return (
        <div className={`visible overlay`}>
            <div className={`show medium popup-primary`}>
                <div className='head-new'>
                    <img src={popupDefaultHeadImage} alt="icon" />
                    <div className='texts'>
                        <h2>
                            {trans('headings.viewActivity')}
                        </h2>
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        </p>
                    </div>
                    <span className='close' onClick={onClose}>

                    </span>
                </div>
                <div className='row'>
                    <div className='col'>
                        <select
                            value={newStatus || order.status}
                            onChange={e => setNewStatus(e.target.value)}
                        >
                            {statusOptions.map(opt => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="footer align-right">
                    <button onClick={onClose}>
                        {trans('buttons.close')}
                    </button>

                    <button
                        onClick={handleSave}
                        className='button-primary'
                        disabled={!newStatus || newStatus === order.status}
                    >
                        {trans('buttons.save')}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ChangeStatusDialog
